import React from 'react';
import GeneralSettings from "../../settings/user/UserGeneralSettings";
import FeedSettings from "../../settings/user/feed/AccountFeed";
import BoardSettings from "../../settings/user/boards/AccountBoards";
import NotificationSettings from "../../settings/user/notifications/AccountNotifications";
import ProfileSettings from "../user/profile/ProfileSettings";
import UserReportHistory from "../../user/UserReportHistory";
import ListAllReports from '../admin/AdminListAllUsers';
// import SettingsNotifications from '../components/settings/user/notifications/AccountNotifications';
// import AccountSideMenu from '../components/settings/user/AccountSideMenu';
// import SubMenu from '../components/menu/submenu';
// import SettingsDropdownMenu from '../components/settings/user/SettingsDropdownMenu';

export const KeysToComponentMap = {
    'general': <GeneralSettings />,
    'home': <FeedSettings />,
    'explore': <ProfileSettings />,
    'boards': <BoardSettings />,
    'feed': <FeedSettings />,
    'alerts': <BoardSettings />,
    'comingsoon': <NotificationSettings />,
    'profile': <ProfileSettings />,
    'history': <UserReportHistory />,
    'users': <ListAllReports />,
    'reports': <ListAllReports />,

}